import React, { useState } from 'react';
import { Colors } from 'library';
import { Card, Chip, Icon, IconButton, Link, Row, Stack, Text } from 'library/ui';
import { ChevronRightRounded } from '@mui/icons-material';
import { AddPaymentMethodModal } from 'shared/payments';

export function PaymentSetupRow({ status, refresh }: { status: string; refresh: () => void }) {
    const [openConnectPayment, setOpenConnectPayment] = useState<boolean>(false);

    const requiredChip = (
        <Chip variant="filled" bgColor={Colors.warning} textColor={Colors.white} size="small">
            Required
        </Chip>
    );

    if (status === 'needs_verified') {
        return (
            <Card to="/payments" padding="sm" tone="warning">
                <Row justify="between" align="center">
                    <Stack gap="none" grow>
                        <Row gap="sm">
                            <Text weight="semibold">Complete your Payment Setup</Text>
                            {requiredChip}
                        </Row>
                        <Text size="sm" tone="secondary">
                            Verify your account to complete payment setup.
                        </Text>
                    </Stack>
                    <Icon icon={ChevronRightRounded} />
                </Row>
            </Card>
        );
    }

    if (status === 'needs_payment' || status === 'need_setup') {
        return (
            <>
                <Card padding="sm" tone="warning">
                    <Row justify="between" align="center">
                        <Stack gap="none" grow>
                            <Row gap="sm">
                                <Link onClick={() => setOpenConnectPayment(true)} underline={false} weight="semibold">
                                    Add a Payment Method
                                </Link>
                                {requiredChip}
                            </Row>
                            <Text size="sm" tone="secondary">
                                Set up a primary payment method on your account.
                            </Text>
                            <Link
                                href="https://chatwoot.join-tandem.com/hc/child-care-center-help-center/en/categories/payments"
                                size="sm"
                            >
                                Learn more about the invoicing process.
                            </Link>
                        </Stack>
                        <IconButton icon={ChevronRightRounded} onClick={() => setOpenConnectPayment(true)} />
                    </Row>
                </Card>
                <AddPaymentMethodModal
                    open={openConnectPayment}
                    onClose={() => setOpenConnectPayment(false)}
                    onSuccess={refresh}
                />
            </>
        );
    }

    return null;
}
